export default {
  namespaced: true,
  victronenergy: {
    title: "Victronenergy",
    master_account: {
      title: "Master Account",
      name: "Name",
      description: "Description",
      api_email: "Api Email",
      api_password: "Api Password",
      api_server: "Api Server",
      token: "Token",
      url_mqtt: "Url mqtt",
    },
    sites: {
      title: "Sites",
      name: "Name",
      description: "Description",
      is_active: "Is Active",
      timezone: "Timezone",
      status: "Status",
      has_mains: "Has Mains",
      has_generator: "Has Generator",
      device_icon: "Device Icon",
      favorite: "Favorite",
      devices: "Devices",
    },
    devices: {
      title: "Devices",
      name: "Name",
      product_name: "Product Name",
      product_code: "Product Code",
      machine_serial_number: "Machine Serial Number",
      firmware_version: "Firmware Version",
      device_class: "Device Class",
      last_connection: "Last Connection",
      gui_v2_status: "GUI V2 Status",
      has_victron_connect: "Has Victron Connect",
    }
  }
};
